/**
 * 대시보드 주간 차트(월요일~일요일)에서 강조할 기본 일(YYYY-MM-DD, 로컬 달력 기준).
 * - 과거 완료된 주: 해당 주의 마지막 일(일요일)
 * - 금주: 일요일이 아직 오지 않았을 수 있으므로 min(일요일, 오늘)
 */

function startOfLocalDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function addLocalDays(d: Date, n: number): Date {
  const x = startOfLocalDay(d);
  x.setDate(x.getDate() + n);
  return x;
}

function getWeekStart(d: Date, weekStartsOn: number): Date {
  const x = startOfLocalDay(d);
  const day = x.getDay();
  const diff = (day - weekStartsOn + 7) % 7;
  x.setDate(x.getDate() - diff);
  return x;
}

function toLocalIsoDateString(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getDashboardWeekChartAnchorIso(
  selectedDate: Date,
  options: { weekStartsOn: number; today?: Date }
): string {
  const cap = startOfLocalDay(options.today ?? new Date());
  const weekStart = getWeekStart(selectedDate, options.weekStartsOn);
  const weekEnd = addLocalDays(weekStart, 6);
  const anchor = weekEnd.getTime() <= cap.getTime() ? weekEnd : cap;
  return toLocalIsoDateString(anchor);
}
